module.exports = __webpack_public_path__ + "img/fuki02_pc.acc29047.png";